module.exports = __webpack_public_path__ + "img/1f9c1.a9969fa.svg";